import React from 'react';
import { Clock3Icon, SearchIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { nowPopularSearches } from '../../data/nowPersonalization';
import { trackSearch } from '../../lib/analytics/events';
import { useStore } from '../../lib/store';
export function NowRecentSearches() {
  const navigate = useNavigate();
  const recentSearches = useStore(state => state.recentSearches);
  const setSearchQuery = useStore(state => state.setSearchQuery);
  const searches = recentSearches.length > 0 ? recentSearches : nowPopularSearches;
  const heading = recentSearches.length > 0 ? 'Search again' : 'Popular searches';
  const search = (query: string) => {
    setSearchQuery(query);
    trackSearch(query, 'now-home');
    navigate(`/category/medicines?from=now&search=${encodeURIComponent(query)}`);
  };
  return <section aria-labelledby="now-searches-heading" data-id="element-4106" data-mp="1sg2mtyywgdr5">
      <div className="mb-3 flex items-center gap-2" data-id="element-4107" data-mp="1newtq01buoh3">
        {recentSearches.length > 0 ? <Clock3Icon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-4108" data-mp="28q5abd8o8att" /> : <SearchIcon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-4109" data-mp="28qwuzt0qco5b" />}
        <h2 id="now-searches-heading" className="text-base font-bold text-brand-ink" data-id="element-4110" data-mp="2do6uk1hu2g6v">{heading}</h2>
      </div>
      <div className="flex gap-2 overflow-x-auto pb-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-id="element-4111" data-mp="1yr60hrc66958">
        {searches.map(query => <button key={query} type="button" onClick={() => search(query)} className="shrink-0 rounded-full border border-brand-border bg-white px-3 py-2 text-sm font-medium text-brand-ink transition-colors duration-150 hover:border-brand hover:bg-brand-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-4112" data-mp="1pznnfpais9gd">
            {query}
          </button>)}
      </div>
    </section>;
}